import {
  PortalArticleBlock,
  PortalArticleCardItem,
  PortalArticleNoteStyle,
  PortalArticleSectionContentItem,
} from '../../../models/PortalArtigoModel'

export const PORTAL_BLOCK_TYPE_LABELS: Record<PortalArticleBlock['type'], string> = {
  intro: 'Introdução',
  summary: 'Índice',
  topic: 'Tópico',
}

export const PORTAL_SECTION_CONTENT_TYPE_LABELS: Record<
  PortalArticleSectionContentItem['type'],
  string
> = {
  paragraph: 'Parágrafo',
  bullets: 'Marcadores',
  note: 'Nota',
  cards: 'Cards',
  image: 'Imagem',
  table: 'Tabela',
  youtube: 'YouTube',
}

export const PORTAL_TABLE_COLUMN_STYLE_OPTIONS = [
  { value: 'default', label: 'Padrão' },
  { value: 'strong', label: 'Negrito' },
  { value: 'accent', label: 'Destaque laranja' },
  { value: 'badge', label: 'Etiqueta' },
] as const

export const PORTAL_TABLE_COLUMN_ALIGN_OPTIONS = [
  { value: 'left', label: 'Esquerda' },
  { value: 'center', label: 'Centro' },
  { value: 'right', label: 'Direita' },
] as const

export const PORTAL_TABLE_COLUMN_WIDTH_OPTIONS = [
  { value: 'auto', label: 'Automática' },
  { value: 'narrow', label: 'Estreita' },
  { value: 'medium', label: 'Média' },
  { value: 'wide', label: 'Larga' },
] as const

export const PORTAL_CARD_KIND_OPTIONS: Array<{
  value: PortalArticleCardItem['kind']
  label: string
}> = [
  { value: 'course', label: 'Curso' },
  { value: 'leadMagnet', label: 'Lead magnet' },
  { value: 'portalPost', label: 'Artigo do Portal' },
]

export const PORTAL_LEAD_MAGNET_OPTIONS = [
  {
    value: 'ebook-guia-motorista-onibus-2026',
    label: 'E-book Guia Motorista de Ônibus 2026',
  },
  {
    value: 'kit-curriculo-motorista-onibus',
    label: 'Kit Currículo Motorista de Ônibus',
  },
]

export const PORTAL_NOTE_VARIANT_OPTIONS = [
  { value: 'default', label: 'Padrão' },
  { value: 'custom', label: 'Personalizado' },
]

export const PORTAL_NOTE_STYLE_VARIANTS: Array<NonNullable<PortalArticleNoteStyle['variant']>> = [
  'custom',
]

export const PORTAL_NOTE_STYLE_COLOR_FIELDS: Array<{
  field: keyof Pick<
    PortalArticleNoteStyle,
    'borderColor' | 'backgroundColor' | 'textColor' | 'strongColor' | 'linkColor'
  >
  label: string
}> = [
  { field: 'borderColor', label: 'borda' },
  { field: 'backgroundColor', label: 'fundo' },
  { field: 'textColor', label: 'texto' },
  { field: 'strongColor', label: 'negrito' },
  { field: 'linkColor', label: 'link' },
]

export const PORTAL_HEX_COLOR_REGEX = /^#(?:[0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/
